import { z } from "zod";
export const DashboardFiltersValidator = z.object({
    categoryIds: z
        .array(z.number().int().positive())
        .optional()
        .transform((val) => (val && val.length > 0 ? val : undefined)),
    partnerIds: z
        .array(z.number().int().positive())
        .optional()
        .transform((val) => (val && val.length > 0 ? val : undefined)),
    search: z
        .string()
        .optional()
        .transform((val) => (val && val.trim() ? val.trim() : undefined)),
    startDate: z.string().datetime().optional(),
    endDate: z.string().datetime().optional(),
    includeVirtualExpenses: z
        .boolean()
        .optional()
        .transform((val) => (val === true ? true : undefined)),
});
